import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { PositionListType } from 'types/kodawari';

/**
 * 仕事内容に関するカスタムフック
 * @param initialPositionList
 * @returns 仕事内容の値と更新する関数を含むオブジェクト
 */
export const usePositions = (initialPositionList: PositionListType[]) => {
  const [positionList, setPositionList] =
    useState<PositionListType[]>(initialPositionList);

  const selectedPositionList = positionList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedPositionList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = positionList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setPositionList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updatePositionListJobCount = (
    requirementsJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setPositionList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(requirementsJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedPositionList = () => {
    const checkedList = positionList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setPositionList(checkedList);
  };

  return {
    positionList,
    selectedPositionList,
    updateIsCheckedPositionList,
    updatePositionListJobCount,
    clearIsCheckedPositionList,
  };
};
